import type { Observable } from "rxjs";
import { filter } from "rxjs";
import { Injectable } from "@snap/ts-inject";
import type { CameraKitConfiguration } from "../configuration";
import { configurationToken } from "../configuration";
import { logEntriesFactory } from "./logEntries";
import type { LogEntry } from "./logger";
import { logLevelMap } from "./logger";

/**
 * The factory subscribes to log entry events and, based on the configured log level,
 * forwards matching log entries to the logger specified in the CameraKit configuration object.
 *
 * @internal
 */
export const registerLogEntriesSubscriber = Injectable(
    "registerLogEntriesSubscriber",
    [configurationToken, logEntriesFactory.token] as const,
    (configuration: CameraKitConfiguration, logEntries: Observable<LogEntry>) => {
        logEntries
            .pipe(filter((entry) => logLevelMap[entry.level] >= logLevelMap[configuration.logLevel]))
            .subscribe((logEntry) => {
                const logMethod = configuration.logger[logEntry.level];
                logMethod(`[CameraKit.${logEntry.module}]`, ...logEntry.messages);
            });
    }
);
